import IronShaft from './IronShaft';

export default IronShaft;
